export function useLocalData() {
  const APP_AUTH_STORAGE_KEY = 'AuthenticationData';
  const APP_AUTH_TOKEN_KEY = 'accessToken';

  function saveLocalData(key, value) {
    const localData = {
      value,
    };
    localStorage.setItem(key, JSON.stringify(localData));
  }

  function getLocalData(key) {
    const localDataString = localStorage.getItem(key);
    if (!localDataString) return null;
    const localData = JSON.parse(localDataString);
    return localData;
  }

  function clearLocalData(key) {
    localStorage.removeItem(key);
  }

  return {
    saveLocalData,
    getLocalData,
    clearLocalData,
    APP_AUTH_STORAGE_KEY,
    APP_AUTH_TOKEN_KEY,
  };
}
